<template>
  <div class="main container">
    <div v-if="!isLoading " class="title-header">
      <div class="row title-container">
        <div class="col-auto">
          <div class="title-header-text">
            {{ CONSTANTS.IT_SERVICE_DIRECTORY }}
          </div>
        </div>
        <div class="col-auto px-lg-0">
          <employee-hub-bookmark :title="CONSTANTS.IT_SERVICE_DIRECTORY" :env="env" show-circle class="d-inline-block"></employee-hub-bookmark>
        </div>
      </div>
    </div>

    <loading-overlay v-if="isLoading || isServicesByRoleLoading"></loading-overlay>

    <div v-if="!isLoading ">
      <div class="row">
        <div class="col-12">
          <div class="services-panel">
<!--            <div class="d-flex justify-content-end services-role-toggle">-->
<!--              <toggle-button-->
<!--                :value="isFilteredByRole"-->
<!--                :sync="true"-->
<!--                :speed="100"-->
<!--                @change="onServiceByRole"-->
<!--              />-->
<!--              <span :class="isFilteredByRole && 'active'">My Role</span>-->
<!--            </div>-->
            <service-directory-platform
              v-if="!isServicesByRoleLoading"
              v-for="(servicePlatform, index) in servicePlatforms"
              :key="index"
              :name="servicePlatform.name"
              :serviceAreas="servicePlatform.serviceAreas"
              @handleClickServiceModal="handleClickServiceModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay";
import * as CONSTANTS from "@/store/constants";
import router from "@/router";
import ServiceModal from "@/components/service-directory/ServiceModal";
import ServiceDirectoryPlatform from "./ServiceDirectoryPlatform";
import { createStandardModal } from "@/utils/modalHelper";

export default {
  name: "service-directory",
  components: {
    LoadingOverlay,
    ServiceModal,
    ServiceDirectoryPlatform
  },
  data() {
    return {
      CONSTANTS,
      isServicesByRoleLoading: false,
      businessServiceMap: new Map(),
      modalInstance: null,
      env: CURRENT_ENV
    };
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "serviceTaxonomy",
      "userServicesByRole",
      "isFilteredByRole"
    ]),
    servicePlatforms() {
      let itServiceAreas = [];
      let itBusinessServiceAreas = [];

      // Convert retrieved service taxonomy into displayable platform information
      this.serviceTaxonomy.forEach(serviceArea => {
        if (serviceArea.id != CONSTANTS.SPECIALIZED_SERVICES) {
          // For normal services, push all of the services under every service line
          let services = [];
          serviceArea.serviceLines.forEach(serviceLine => {
            serviceLine.services.forEach(service => {
              services.push(service);
              this.businessServiceMap.set(service.id, service.legacySysId);
            });
          });
          services.sort(this.sortServiceHierarchyItems);
          itServiceAreas.push({
            name: serviceArea.name,
            services
          });
        } else {
          // For the business services, treat the service line as the service areas for the platform
          serviceArea.serviceLines.forEach(serviceLine => {
            // Add business services to the map as well
            serviceLine.services.forEach(service => {
              this.businessServiceMap.set(service.id, service.legacySysId);
            });

            itBusinessServiceAreas.push({
              name: serviceLine.name,
              services: serviceLine.services.sort(
                this.sortServiceHierarchyItems
              )
            });
            itBusinessServiceAreas.sort(this.sortServiceHierarchyItems);
          });
        }
      });
      let platforms = [
        {
          name: CONSTANTS.IT_SERVICES,
          serviceAreas: itServiceAreas
        },
        {
          name: CONSTANTS.IT_BUSINESS_SERVICES,
          serviceAreas: itBusinessServiceAreas
        }
      ];

      // Apply user filtering
      if (this.isFilteredByRole && this.userServicesByRole.length) {
        platforms.forEach(platform => {
          platform.serviceAreas.forEach(serviceArea => {
            // Remove all services that by role is not defined
            serviceArea.services = serviceArea.services.filter(service => {
              return this.userServicesByRole.some(
                serviceByRole => serviceByRole.name == service.name
              );
            });
          });

          // Remove all service areas that no longer have a service
          platform.serviceAreas = platform.serviceAreas.filter(
            serviceArea => serviceArea.services.length
          );
        });
        this.isServicesByRoleLoading = false;
      }
      return platforms;
    }
  },
  watch: {
    '$route.params.id'(newId) {
      // Watch for route param changes and open modal
      if (newId && this.serviceTaxonomy.length > 0) {
        if (this.businessServiceMap.has(newId)) {
          this.openServiceModal(newId);
        } else if ([...this.businessServiceMap.values()].includes(newId)) {
          let key = [...this.businessServiceMap.entries()].find(([key, value]) => value === newId)[0];
          this.openServiceModal(key);
        }
      }
    }
  },
  created() {
    safeImportComponent(HH_COMPONENTS_URL + "/helphubservice.umd.min.js");

    this.fetchServiceTaxonomy("IT")
        .then(() => {
          // open the modal if the url has a serviceId parameter
          if (this.$route.params.id) {
            let serviceId = this.$route.params.id;
            if (this.businessServiceMap.has(serviceId)) {
              this.openServiceModal(serviceId);
            } else if ([...this.businessServiceMap.values()].includes(serviceId)) {
              let key = [...this.businessServiceMap.entries()].find(([key, value]) => value === serviceId)[0];
              this.openServiceModal(key);
            } else {
              this.$router.push("/service-directory");
            }
          }
        })
        .catch(() => {
          this.$router.push({ name: "error" });
        });
  },
  methods: {
    ...mapMutations(["setIsFilteredByRole"]),
    ...mapActions(["fetchServiceTaxonomy", "fetchUserServicesByRole"]),

    handleClickServiceModal(service) {
      this.openServiceModal(service.id);
      this.$hhMixpanel.trackEvent("Page Hit: " + service.name);
    },
    sortServiceHierarchyItems(a, b) {
      return a.name.localeCompare(b.name);
    },
    onServiceByRole(event) {
      if (this.userServicesByRole.length == 0) {
        this.isServicesByRoleLoading = true;
        this.fetchUserServicesByRole(true).catch(() => {
          this.isServicesByRoleLoading = false;
        });
      }
      this.setIsFilteredByRole(event.value);

      const eventLabel = this.isFilteredByRole
        ? "Services By Role"
        : "All services";
      this.$hhMixpanel.trackEvent(`Page Hit: ${eventLabel}`);
    },
    handleClickServiceModal(service) {
      // Extract serviceId from service object (child component emits the whole service)
      const serviceId = typeof service === 'object' ? service.id : service;
      // Just navigate - the created() hook will open the modal
      this.$router.push(`/service-directory/${serviceId}`);
    },

    openServiceModal(serviceId) {
      // Create modal instance using vue-final-modal v4 API
      this.modalInstance = createStandardModal(ServiceModal, {
        props: {
          serviceId
        },
        attrs: {
          class: 'vfm-modal-center eh-service-modal'
        },
        callbacks: {
          onBeforeClose: () => {
            this.$router.push("/service-directory");
          }
        },
        maxWidth: '1200px'
      });

      // Open the modal
      this.modalInstance.open();
    }
  },

  beforeUnmount() {
    // Cleanup modal instance when component is destroyed
    if (this.modalInstance) {
      this.modalInstance.destroy();
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #ffffff !important;
}
.services-panel {
  background-color: #ffffff;
  padding: 35px 60px;
  margin: 39px 0px;
  height: auto;
  min-height: 700px;
  border: 1px solid #cccccc;
  border-radius: 4px;
}
@media (max-width: 767px) {
  .services-panel {
    padding: 15px 30px;
    margin: 15px 0px;
  }
  .title-header-text {
    font-size: 18px !important;
    padding-top: 22px !important;
  }
}
.title-header-text {
  color: #000000;
  font-size: 38px;
  font-weight: bold;
  line-height: 25px;
  font-family: artifaktElementBold;
}
.title-header {
  height: auto;
}
.title-container {
  display: flex;
  align-content: center;
  align-items: center;
  padding-top: 39px;
}
.it-services-panel {
  margin-bottom: 50px;
}
.it-business-panel {
  margin-bottom: 20px;
}

.services-role-toggle span {
  margin: -5px 5px 0 15px;
}
.services-role-toggle span.active {
  color: #0696d7;
}

/* modal ovverrides */

.eh-bookmark {
  margin-top: 18px;
}

.eh-service-modal {
  border-radius: 0;
}

@media(min-width: 768px) and (max-height: 1280px) {
  employee-hub-bookmark :deep(.bookmark-icon) {
    margin-left: 0px !important;
    margin-top: 9px !important;
  }
}

@media(min-width: 300px) and (max-height: 915px) {
  employee-hub-bookmark :deep(.bookmark-icon) {
    margin-left: -15px !important;
    margin-top: 29px !important;
    font-size:20px !important;
  }
}

@media (min-width: 1025px) {
employee-hub-bookmark :deep(.bookmark-icon) {
  margin-left: 4px !important;
  margin-top: 9px !important;
}
}

@media only screen and (min-width: 1366px) and (max-height: 768px),
only screen and (min-width: 1280px) and (max-height: 800px){
employee-hub-bookmark :deep(.bookmark-icon) {
  margin-left: 4px !important;
  margin-top: 12px !important;
  font-size:28px !important;
}
}
</style>
